/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import React from 'react';
import styles from './icon.less';

import { TestId } from '@trello/webdriverio-tests';

export enum IconColor {
  Blue = 'blue',
  Gray = 'gray',
  Green = 'green',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  Light = 'light',
  Dark = 'dark',
  Yellow = 'yellow',
}

export enum IconName {
  Activity = 'activity',
  Add = 'add',
  AddMember = 'add-member',
  AddReaction = 'add-reaction',
  Admin = 'admin-chevron',
  AppStore = 'app-store',
  AppSwitcher = 'application-switcher',
  Archive = 'archive',
  Attachment = 'attachment',
  Back = 'back',
  Board = 'board',
  Box = 'box',
  BusinessClass = 'business-class',
  ButlerBot = 'butler-bot',
  Calendar = 'calendar',
  Camera = 'camera',
  Card = 'card',
  CardAging = 'card-aging',
  CardCover = 'card-cover',
  CardRecurring = 'card-recurring',
  Check = 'check',
  CheckboxChecked = 'checkbox-checked',
  CheckboxIndeterminate = 'checkbox-indeterminate',
  CheckboxUnchecked = 'checkbox-unchecked',
  Checklist = 'checklist',
  Clock = 'clock',
  Close = 'close',
  Collection = 'collection',
  Comment = 'comment',
  Copy = 'copy',
  CustomField = 'custom-field',
  Description = 'description',
  Documents = 'documents',
  Down = 'down',
  Download = 'download',
  Dropbox = 'dropbox',
  DropdownOptions = 'dropdown-options',
  Edit = 'edit',
  Email = 'email',
  Emoji = 'emoji',
  Enterprise = 'enterprise',
  EnterpriseDashboard = 'enterprise-dashboard',
  ExternalLink = 'external-link',
  Facebook = 'facebook',
  Filter = 'filter',
  Fogbugz = 'fogbugz',
  Forward = 'forward',
  Gear = 'gear',
  Github = 'github',
  Google = 'google',
  GoogleDrive = 'google-drive',
  Heart = 'heart',
  Help = 'help',
  Home = 'home',
  House = 'house',
  Image = 'image',
  Information = 'information',
  Instagram = 'instagram',
  Kiln = 'kiln',
  Label = 'label',
  LeaveBoard = 'leave-board',
  Lightbulb = 'lightbulb',
  LightbulbLit = 'lightbulb-lit',
  List = 'list',
  Location = 'location',
  LogOut = 'log-out',
  Member = 'member',
  Mention = 'mention',
  Microphone = 'microphone',
  MicrophoneOff = 'microphone-off',
  Move = 'move',
  Nearby = 'nearby',
  Notification = 'notification',
  Number = 'number',
  Onedrive = 'onedrive',
  OpenSource = 'open-source',
  Organization = 'organization',
  OrganizationVisible = 'organization-visible',
  OverflowMenuHorizontal = 'overflow-menu-horizontal',
  OverflowMenuVertical = 'overflow-menu-vertical',
  PasswordManager = 'password-manager',
  PowerUp = 'power-up',
  Preferences = 'preferences',
  Private = 'private',
  Public = 'public',
  Refresh = 'refresh',
  Remove = 'remove',
  RemoveMember = 'remove-member',
  Reply = 'reply',
  Screenshare = 'screenshare',
  Search = 'search',
  SelectionMode = 'selection-mode',
  Send = 'send',
  Share = 'share',
  Sparkle = 'sparkle',
  Star = 'star',
  Starred = 'starred',
  Sticker = 'sticker',
  Subscribe = 'subscribe',
  Sync = 'sync',
  Taco = 'taco',
  TemplateCreate = 'template-create',
  TemplateBoard = 'template-board',
  TemplateCard = 'template-card',
  Text = 'text',
  Trash = 'trash',
  TrelloGold = 'trello-gold',
  Twitter = 'twitter',
  Up = 'up',
  Upload = 'upload',
  Video = 'video',
  VideoOff = 'video-off',
  Vote = 'vote',
  Warning = 'warning',
}

// These are all SVG icons. Once they get incorporated into the official
// Trellicons font, they should be removed from this list.
const SVGIcons = new Set([IconName.CheckboxIndeterminate]);

export interface IconProps {
  large?: boolean;
  medium?: boolean;
  small?: boolean;
  quiet?: boolean;
  name: IconName;
  color?: IconColor;
  className?: string;
  testId?: TestId;
}

const Icon = (props: IconProps) => {
  const { large, medium, small, quiet, testId, ...rest } = props;
  const custom = SVGIcons.has(props.name);

  const className = classNames(
    styles.icon,
    large && styles['icon-lg'],
    medium && styles['icon-md'],
    small && styles['icon-sm'],
    quiet && styles['mod-quiet'],
    custom && styles['icon-custom'],
    styles[`icon-${props.name}`],
    props.color ? styles[`icon-${props.color}`] : null,
    props.className,
  );

  return (
    <span
      {...rest}
      className={className}
      data-test-id={testId}
      role="presentation"
    />
  );
};

export default Icon;
